import { Box, Button, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const CreateAutomationSchedule = observer(({ automationStore }) => {
  const [interval, setInterval] = useState(false);
  const [generateReport, setGenerateReport] = useState(false);
  const [reportEmails, setReportEmails] = useState(false);
  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <Typography>
            <h3>Intervalo entre as ações (seg.)</h3>
          </Typography>
          <TextField id='interval' value={automationStore.scheduleInterval} variant='outlined'
                     onChange={e => automationStore.setScheduleInterval(e.target.value)}
                     fullWidth />
          <br /><br />
          <Typography fontSize='small'>
            {automationStore.selectedUsersCount > 1 && automationStore.actionsQty > 0 &&
              `As interações com os ${automationStore.resultSize} usuários selecionados serão realizadas em ${automationStore.estimateTimeExecution}`
            }
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>
            <h3>Gerar relatório final?</h3>
          </Typography>
          <FormControl fullWidth>
            <Select
              value={automationStore.scheduleGenerateReport}
              onChange={e => automationStore.setScheduleGenerateReport(e.target.value)}
            >
              <MenuItem value={false}>Não</MenuItem>
              <MenuItem value={true}>Sim</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <Typography>
            <h3>E-mail para envio do relatório</h3>
          </Typography>
          <TextField id='reportEmails' value={automationStore.scheduleReportEmails} variant='outlined'
                     onChange={e => automationStore.setScheduleReportEmails(e.target.value)}
                     fullWidth />
          <br /><br />
          <Typography fontSize='small'>
            Caso deseje enviar para mais de um e-mail, separe-os por vírgula “,” sem espaços.
          </Typography>
        </Grid>
      </Grid>
      <br /><br />
      <Grid container spacing={4} justifyContent='flex-end'>
        <Grid item xs={12}>
          <Box display='flex' justifyContent='flex-end'>
            <Button variant='contained' onClick={async (e) => {
              await automationStore.saveSchedule();
            }}>Executar</Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
});

export default CreateAutomationSchedule;
